(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection_carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rinen-ritual-carousel')) {
    customElements.define('rinen-ritual-carousel', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.rinen-ritual-grid__list');
        if (!this.list) return;
        this.cards = [...this.list.querySelectorAll(':scope > .rinen-ritual-card')];
        this.dots = [...this.querySelectorAll('.rinen-ritual-carousel__dot')];
        this.prev = this.querySelector('.rinen-ritual-carousel__arrow[data-dir="-1"]');
        this.next = this.querySelector('.rinen-ritual-carousel__arrow[data-dir="1"]');
        this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = null; this.update(); }); };
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        this.dots.forEach((d) => d.addEventListener('click', () => this.goTo(+d.dataset.index)));
        [this.prev, this.next].forEach((b) => b && b.addEventListener('click', () => this.goTo(this.activeIndex() + +b.dataset.dir)));
        // Theme editor: bring the selected card into view
        // Whole card clickable: a click anywhere on a card does what its main button does.
        // Real buttons/links inside the card (e.g. One Time Purchase) keep working as normal.
        if (this.list.hasAttribute('data-card-click')) {
          this.list.addEventListener('click', (e) => {
            if (window.Shopify && Shopify.designMode) return; // theme editor: clicks select the card
            if (e.target.closest('a, button, input, select, textarea, label, form')) return;
            if (String(window.getSelection && window.getSelection()).trim()) return; // selecting text
            const card = e.target.closest('.rinen-ritual-card');
            const cta = card && card.querySelector('.rinen-ritual-card__cta');
            if (!cta) return;
            if (cta.href && (e.metaKey || e.ctrlKey || e.button === 1)) window.open(cta.href, '_blank');
            else cta.click();
          });
        }
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.cards.indexOf(e.target.closest('.rinen-ritual-card'));
          if (i > -1) this.goTo(i, 'auto');
        });
        this.ro = new ResizeObserver(() => { this.alignPriceRows(); this.update(); });
        this.ro.observe(this.list);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.alignPriceRows());
        this.alignPriceRows();
        this.update();
      }
      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.list) this.list.removeEventListener('scroll', this.onScroll);
      }
      // Line up the divider above the price on every card
      alignPriceRows() {
        if (!this.list.hasAttribute('data-align-prices')) return;
        const rows = this.cards.map((c) => c.querySelector('.rinen-ritual-card__price-row'));
        rows.forEach((r) => r && (r.style.marginTop = ''));
        const tops = rows.map((r, i) => (r ? r.getBoundingClientRect().top - this.cards[i].getBoundingClientRect().top : null));
        const valid = tops.filter((t) => t !== null);
        if (valid.length < 2) return;
        const lowest = Math.max(...valid);
        rows.forEach((r, i) => { if (r && lowest - tops[i] > 0.5) r.style.marginTop = lowest - tops[i] + 'px'; });
      }
      activeIndex() {
        const l = this.list;
        if (l.scrollLeft >= l.scrollWidth - l.clientWidth - 2) return this.cards.length - 1;
        let best = 0, dist = Infinity;
        this.cards.forEach((c, i) => { const d = Math.abs(c.offsetLeft - l.scrollLeft); if (d < dist) { dist = d; best = i; } });
        return best;
      }
      goTo(i, behavior = 'smooth') {
        const card = this.cards[Math.max(0, Math.min(this.cards.length - 1, i))];
        if (card) this.list.scrollTo({ left: card.offsetLeft, behavior });
      }
      update() {
        const l = this.list, max = l.scrollWidth - l.clientWidth, idx = this.activeIndex();
        this.toggleAttribute('data-overflowing', l.scrollWidth > l.clientWidth + 2);
        this.dots.forEach((d, i) => d.setAttribute('aria-current', i === idx ? 'true' : 'false'));
        if (this.prev) this.prev.disabled = l.scrollLeft <= 2;
        if (this.next) this.next.disabled = l.scrollLeft >= max - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
